<script>
import axios from 'axios'
import moment from 'moment'
const weekdaysDefault = [0, 1, 2, 3, 4, 5, 6]

const intervalsDefault = {
  first: 0,
  minutes: 60,
  count: 24,
  height: 40
}

const stylings = {
  default(interval) {
    return undefined
  },
  workday(interval) {
    const inactive =
      interval.weekday === 0 ||
      interval.weekday === 6 ||
      interval.hour < 9 ||
      interval.hour >= 17
    const startOfHour = interval.minute === 0
    const mid = this.$vuetify.dark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'

    return {
      backgroundColor: inactive
        ? this.$vuetify.dark
          ? 'rgba(0,0,0,0.4)'
          : 'rgba(0,0,0,0.05)'
        : undefined,
      borderTop: startOfHour ? undefined : '1px dashed ' + mid
    }
  },
  past(interval) {
    return {
      backgroundColor: interval.past
        ? this.$vuetify.dark
          ? 'rgba(0,0,0,0.4)'
          : 'rgba(0,0,0,0.05)'
        : undefined
    }
  }
}
export default {
  name: 'JobScheduleCalendar',
  props: {
    jobSchedule: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    loader: false,
    schedules: [],
    startMenu: false,
    start: null,
    calendarEnable: false,
    endMenu: false,
    end: null,
    minWeeks: 1,
    eventCount: 100,
    eventCountItems: [50, 100, 300, 500, 1000],
    now: moment().format('YYYY-MM-DD'),
    type: 'month',
    typeOptions: [
      { text: 'Day', value: 'day' },
      { text: 'Week', value: 'week' },
      { text: 'Month', value: 'month' },
      { text: 'Custom Daily', value: 'custom-daily' },
      { text: 'Custom Weekly', value: 'custom-weekly' }
    ],
    weekdays: weekdaysDefault,
    weekdaysOptions: [
      { text: 'Sunday - Saturday', value: weekdaysDefault },
      { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
      { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] }
    ],
    intervals: intervalsDefault,
    intervalsOptions: [
      { text: 'Default', value: intervalsDefault },
      {
        text: 'Workday',
        value: { first: 16, minutes: 30, count: 20, height: 40 }
      }
    ],
    maxDays: 7,
    maxDaysOptions: [
      { text: '7 days', value: 7 },
      { text: '5 days', value: 5 },
      { text: '4 days', value: 4 },
      { text: '3 days', value: 3 }
    ],
    styleInterval: 'default',
    styleIntervalOptions: [
      { text: 'Default', value: 'default' },
      { text: 'Workday', value: 'workday' },
      { text: 'Past', value: 'past' }
    ],
    color: 'blue',
    colorOptions: [
      { text: 'Red', value: 'red' },
      { text: 'Pink', value: 'pink' },
      { text: 'Purple', value: 'purple' },
      { text: 'Deep Purple', value: 'deep-purple' },
      { text: 'Indigo', value: 'indigo' },
      { text: 'Blue', value: 'blue' },
      { text: 'Light Blue', value: 'light-blue' },
      { text: 'Cyan', value: 'cyan' },
      { text: 'Teal', value: 'teal' },
      { text: 'Green', value: 'green' },
      { text: 'Light Green', value: 'light-green' },
      { text: 'Lime', value: 'lime' },
      { text: 'Yellow', value: 'yellow' },
      { text: 'Amber', value: 'amber' },
      { text: 'Orange', value: 'orange' },
      { text: 'Deep Orange', value: 'deep-orange' },
      { text: 'Brown', value: 'brown' },
      { text: 'Blue Gray', value: 'blue-gray' },
      { text: 'Gray', value: 'gray' },
      { text: 'Black', value: 'black' }
    ]
  }),
  mounted() {
    this.init()
    this.getData()
  },
  watch: {
    start() {
      if (!this.hasEnd) {
        switch (this.type) {
          case 'day':
            this.end = moment(this.start)
              .add(1, 'days')
              .format('YYYY-MM-DD')
            break
          case 'week':
            this.end = moment(this.start)
              .add(1, 'weeks')
              .format('YYYY-MM-DD')
            break
          case 'month':
            this.end = moment(this.start)
              .add(1, 'months')
              .format('YYYY-MM-DD')
            break
        }
      }
      this.getData()
    },
    end() {
      this.getData()
    },
    eventCount() {
      this.getData()
    }
  },
  computed: {
    getHeading() {
      return (
        moment(this.start).format('DD MMMM YYYY') +
        ' to ' +
        moment(this.end).format('DD MMMM YYYY')
      )
    },
    intervalStyle() {
      return stylings[this.styleInterval].bind(this)
    },
    hasIntervals() {
      return (
        this.type in
        {
          week: 1,
          day: 1,
          'custom-daily': 1
        }
      )
    },
    hasEnd() {
      return (
        this.type in
        {
          'custom-weekly': 1,
          'custom-daily': 1
        }
      )
    }
  },
  methods: {
    init() {
      this.start = moment()
        .subtract(1, 'days')
        .format('YYYY-MM-DD')
      this.end = moment()
        .add(30, 'days')
        .format('YYYY-MM-DD')
    },
    getData() {
      this.loader = true
      this.calendarEnable = false
      axios
        .get(
          `/api/v1/jobSchedules/${this.jobSchedule.hexId}/schedules?startDate=${this.start}&endDate=${this.end}&scheduleCount=${this.eventCount}`
        )
        .then(response => {
          this.schedules = response.data.map(item => {
            item.date = moment(item.schedule).format('YYYY-MM-DD')
            item.time = moment(item.schedule).format('HH:mm')
            item.hour = parseInt(moment(item.schedule).format('HH'))
            if (item.duration === 0.0) {
              item.duration = 180
            } else {
              item.duration = Math.round(item.duration)
            }
            return item
          })
          this.loader = false
          this.calendarEnable = true
        })
        .catch(error => {
          this.loader = false
          this.calendarEnable = true
          console.log(error)
        })
      this.calendarEnable = true
    },
    showIntervalLabel(interval) {
      return interval.minute === 0
    }
  }
}
</script>

<template>
  <v-layout wrap>
    <v-flex xs12>
      <kbd class="subheading mb-2 beez-bold"
        >Current Selection: {{ getHeading }}</kbd
      >
    </v-flex>
    <v-flex sm12 lg3 class="pa-3 mb-3 feature-pane">
      <v-btn
        fab
        outline
        small
        absolute
        left
        color="secondary"
        @click="$refs.calendar.prev()"
      >
        <v-icon>
          keyboard_arrow_left
        </v-icon>
      </v-btn>
      <v-btn
        fab
        outline
        small
        absolute
        right
        color="secondary"
        @click="$refs.calendar.next()"
      >
        <v-icon>
          keyboard_arrow_right
        </v-icon>
      </v-btn>
      <br /><br /><br />
      <v-select v-model="type" :items="typeOptions" label="Type"></v-select>
      <v-select v-model="color" :items="colorOptions" label="Color"></v-select>
      <v-menu
        ref="startMenu"
        v-model="startMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="start"
        transition="scale-transition"
        min-width="290px"
        lazy
        offset-y
        full-width
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="start"
            label="Start Date"
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="start" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn @click="startMenu = false">
            Cancel
          </v-btn>
          <v-btn @click="$refs.startMenu.save(start)">
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
      <v-menu
        v-if="hasEnd"
        ref="endMenu"
        v-model="endMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        :return-value.sync="end"
        transition="scale-transition"
        min-width="290px"
        lazy
        offset-y
        full-width
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="end"
            label="End Date"
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="end" no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn @click="endMenu = false">
            Cancel
          </v-btn>
          <v-btn @click="$refs.endMenu.save(end)">
            OK
          </v-btn>
        </v-date-picker>
      </v-menu>
      <v-select
        v-model="weekdays"
        :items="weekdaysOptions"
        label="Weekdays"
      ></v-select>
      <v-text-field
        v-if="type === 'custom-weekly'"
        v-model="minWeeks"
        label="Minimum Weeks"
        type="number"
      ></v-text-field>
      <v-select
        v-if="hasIntervals"
        v-model="intervals"
        :items="intervalsOptions"
        label="Intervals"
      ></v-select>
      <v-select
        v-if="type === 'custom-daily'"
        v-model="maxDays"
        :items="maxDaysOptions"
        label="# of Days"
      ></v-select>
      <v-select
        v-if="hasIntervals"
        v-model="styleInterval"
        :items="styleIntervalOptions"
        label="Styling"
      ></v-select>
      <v-select
        v-model="eventCount"
        :items="eventCountItems"
        label="Number of schedules to Fetch"
      ></v-select>
    </v-flex>
    <v-flex sm12 lg9 class="pl-3">
      <v-calendar
        v-if="calendarEnable"
        ref="calendar"
        v-model="start"
        :type="type"
        :start="start"
        :end="end"
        :min-weeks="minWeeks"
        :max-days="maxDays"
        :now="now"
        :weekdays="weekdays"
        :first-interval="intervals.first"
        :interval-minutes="intervals.minutes"
        :interval-count="intervals.count"
        :interval-height="intervals.height"
        :interval-style="intervalStyle"
        :show-interval-label="showIntervalLabel"
        :color="color"
      >
        <template v-slot:day="{ date }">
          <div
            v-if="schedules.filter(item => item.date === date).length > 0"
            class="my-event"
            v-html="
              'Total Schedules: ' +
                schedules.filter(item => item.date === date).length
            "
          ></div>
        </template>
        <template v-slot:dayHeader="{ date }">
          <div
            class="my-event"
            v-html="
              'Total Schedules: ' +
                schedules.filter(item => item.date === date).length
            "
          ></div>
        </template>
        <template v-slot:interval="{ date, hour, timeToY, minutesToPixels }">
          <template
            v-for="event in schedules.filter(
              item =>
                item.date === date &&
                (item.hour >= hour && item.hour < hour + 1)
            )"
          >
            <div
              v-if="event.time"
              class="my-event with-time"
              :style="{
                backgroundColor: color,
                top: timeToY(event.time) + 'px',
                height: minutesToPixels(event.duration) + 'px'
              }"
              v-html="event.title"
            ></div>
          </template>
        </template>
      </v-calendar>
    </v-flex>
  </v-layout>
</template>

<style scoped>
.feature-pane {
  position: relative;
  padding-top: 30px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.day-header {
  margin: 0px 2px 2px 2px;
  padding: 2px 6px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  border-radius: 2px;
  user-select: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.day-body {
  position: absolute;
  top: 400px;
  height: 36px;
  margin: 2px;
  padding: 2px 6px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  border-radius: 2px;
  left: 0;
  right: 0;
  user-select: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.day {
  position: relative;
  height: 24px;
  margin: 0px;
  padding: 0px 6px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  border-radius: 2px;
  left: 0;
  right: 0;
  user-select: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 4px;
  margin-right: 8px;
  position: relative;

  &.with-time {
    position: absolute;
    right: 4px;
    margin-right: 0px;
  }
}
</style>
